import { USER_ROLES } from "../actions/utilities";

const INITIAL_STATE = {
    getUserRolesLoading: false,
    getUserRolesSuccess: false,
    getUserRolesFailure: false,
    getUserRolesError: null,
    addUserRoleLoading: false,
    addUserRoleSuccess: false,
    addUserRoleFailure: false,
    addUserRoleError: null,
    editUserRoleLoading: false,
    editUserRoleSuccess: false,
    editUserRoleFailure: false,
    editUserRoleError: null,
    deleteUserRoleLoading: false,
    deleteUserRoleSuccess: false,
    deleteUserRoleFailure: false,
    deleteUserRoleError: null,
    userRoleList: []
}

export const userRoleReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case USER_ROLES.GET_ALL_USER_ROLES_REQUEST:
            return {
                ...state,
                getUserRolesLoading: true,
                getUserRolesSuccess: false,
                getUserRolesFailure: false,
                getUserRolesError: null,
            }
        case USER_ROLES.GET_ALL_USER_ROLES_SUCCESS:
            return {
                ...state,
                getUserRolesLoading: false,
                getUserRolesSuccess: true,
                getUserRolesFailure: false,
                getUserRolesError: null,
                userRoleList: action.payload
            }
        case USER_ROLES.GET_ALL_USER_ROLES_FAILURE:
            return {
                ...state,
                getUserRolesLoading: false,
                getUserRolesSuccess: false,
                getUserRolesFailure: true,
                getUserRolesError: action.payload,
            }
        case USER_ROLES.ADD_NEW_USER_ROLE_REQUEST:
            return {
                ...state,
                addUserRoleLoading: true,
                addUserRoleSuccess: false,
                addUserRoleFailure: false,
                addUserRoleError: null,
            }
        case USER_ROLES.ADD_NEW_USER_ROLE_SUCCESS:
            let a = state.userRoleList;
            a.push(action.payload);
            return {
                ...state,
                addUserRoleLoading: false,
                addUserRoleSuccess: true,
                addUserRoleFailure: false,
                addUserRoleError: null,
                userRoleList: a
            }
        case USER_ROLES.ADD_NEW_USER_ROLE_FAILURE:
            return {
                ...state,
                addUserRoleLoading: false,
                addUserRoleSuccess: false,
                addUserRoleFailure: true,
                addUserRoleError: action.payload,
            }
        case USER_ROLES.EDIT_USER_ROLE_REQUEST:
            return {
                ...state,
                editUserRoleLoading: true,
                editUserRoleSuccess: false,
                editUserRoleFailure: false,
                editUserRoleError: null,
            }
        case USER_ROLES.EDIT_USER_ROLE_SUCCESS:
            let b = state.userRoleList;
            for (var i = 0; i < b.length; i++) {
                if (b[i].userId === action.payload.userId) {
                    b[i] = action.payload;
                }
            }
            return {
                ...state,
                editUserRoleLoading: false,
                editUserRoleSuccess: true,
                editUserRoleFailure: false,
                editUserRoleError: null,
                userRoleList: b
            }
        case USER_ROLES.EDIT_USER_ROLE_FAILURE:
            return {
                ...state,
                editUserRoleLoading: false,
                editUserRoleSuccess: false,
                editUserRoleFailure: true,
                editUserRoleError: action.payload,
            }
        case USER_ROLES.DELETE_USER_ROLE_REQUEST:
            return {
                ...state,
                deleteUserRoleLoading: true,
                deleteUserRoleSuccess: false,
                deleteUserRoleFailure: false,
                deleteUserRoleError: null,
            }
        case USER_ROLES.DELETE_USER_ROLE_SUCCESS:
            let c = state.userRoleList;
            for (var i = 0; i < c.length; i++) {
                if (c[i].userRoleId === action.payload) {
                    c.splice(i, 1);
                }
            }

            return {
                ...state,
                deleteUserRoleLoading: false,
                deleteUserRoleSuccess: true,
                deleteUserRoleFailure: false,
                deleteUserRoleError: null,
                userRoleList: c
            }
        case USER_ROLES.DELETE_USER_ROLE_FAILURE:
            return {
                ...state,
                deleteUserRoleLoading: false,
                deleteUserRoleSuccess: false,
                deleteUserRoleFailure: true,
                deleteUserRoleError: action.payload,
            }
        default:
            return state;
    }
}